/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import AddLocation from '@material-ui/icons/AddLocation';
import ChevronRight from '@material-ui/icons/ChevronRight';
import clsx from 'clsx';
import useStyles from './styles';

function Address() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { address, modality } = useSelector(state => state.order.order);

  function handleAdresses() {
    dispatch({ type: '@adresses/MODAL' });
  }

  return address && modality === 0 ? (
    <div className={classes.root}>
      <span className={classes.title}>Entregar em</span>
      <div
        className={clsx(classes.body, {
          [classes.invalid]: !address.validated,
        })}
        onClick={handleAdresses}
      >
        <AddLocation />
        <ul className={classes.fields}>
          <li className={classes.name}>
            <strong>{address.name}</strong>
          </li>
          <li>
            {` ${address.zip_code}`}
            {` ${address.public_place}`}
            {` ${address.number},`}
            {` ${address.state}`}
            {` ${address.city}`}
            {` ${address.neighborhood}`}
          </li>
        </ul>
        <ChevronRight />
      </div>
    </div>
  ) : null;
}

export default Address;
